import { useShowSubscriber } from 'modules/for-verification/hooks';
import Pagination from 'partial/components/Pagination';
import Table from 'partial/components/Table';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Badge from 'modules/common/components/Badge';
import { useOrgBanLogs } from '../hooks';

function BanLogs() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [filter, setFilter] = useState({ page: 1 });
  const [isLoading, list, meta] = useOrgBanLogs(filter, orgUuid);

  const format = [
    {
      label: 'type',
      id: 'type',
      key: (item) => (
        <div className="w-full">
          <Badge status={item?.type} />
        </div>
      ),
      labelClassName: 'justify-center',
    },
    {
      label: 'action',
      id: 'action',
      key: (item) => <div>{item?.is_manual ? 'Manual' : 'Banned Word'}</div>,
    },
    { label: 'Banned Word', id: 'banned_word', key: 'ban_word' },
    { label: 'Content', id: 'content', key: 'content' },
    { label: 'Reason', id: 'reason', key: 'reason' },
  ];
  return (
    <div className="h-full flex flex-col space-y-10">
      <Table isLoading={isLoading} data={list} format={format} />
      <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div>
    </div>
  );
}

export default BanLogs;
